// extracted by mini-css-extract-plugin
export var gridMedia = "twoColumnMedia-module--gridMedia--f8f27";
export var left = "twoColumnMedia-module--left--7943a";
export var right = "twoColumnMedia-module--right--9230f";
export var videoThumbnail = "twoColumnMedia-module--videoThumbnail--c83c2";